import { SxProps, Theme } from '@mui/material';

export const dashboardStyles: Record<string, SxProps<Theme>> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    p: 1,
    bgcolor: '#1a1a1a',
    height: 'calc(100vh - 48px)', // 전역 스크롤 해제 후, 페이지 내부 스크롤용 고정 높이
    overflow: 'hidden' // 내부 패널에서만 스크롤
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    fontWeight: 600,
    color: '#fff',
    fontSize: '1.05rem'
  },
  paper: {
    p: 1,
    bgcolor: '#2a2a2a',
    borderRadius: 0.5,
    border: '1px solid #333'
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 360,
    color: '#888'
  },
  table: {
    bgcolor: '#222',
    borderRadius: 1,
    border: '1px solid #444'
  },
  tableHeaderCell: {
    color: '#fff',
    fontWeight: 700,
    fontSize: 15,
    borderBottom: '1px solid #444'
  },
  tableCell: {
    color: '#fff',
    fontWeight: 500,
    borderBottom: '1px solid #444'
  },
  datePicker: {
    width: '150px',
    '& .MuiInputBase-root': {
      height: '40px',
    },
    '& .MuiInputLabel-root': {
      transform: 'translate(14px, 11px) scale(1)',
      '&.Mui-focused, &.MuiFormLabel-filled': {
        transform: 'translate(14px, -9px) scale(0.75)',
      },
    },
  },
  summaryCard: {
    px: 1.2,
    py: 1,
    borderRadius: 0.5,
    bgcolor: '#2a2a2a',
    minWidth: 120,
  },
  chartContainer: {
    height: 360
  }
}; 